import BaseReportFormatUtils from "../FormatUtils";
import {ReportGroupingLevel} from "../constants";
import BalanceType from "../../enums/BalanceType";
import messageResource from "../../messageResource"

export default class LeavesReportFormatUtils extends BaseReportFormatUtils {

    static formatBalance(balance, balanceType, defaultWorkDayDuration) {
        if (_.isNumber(balance)) {
            if (balanceType == BalanceType.PTO && window.SystemSettings.showPTOInHours || balanceType == BalanceType.SICK && window.SystemSettings.showSickInHours)
                balance *= defaultWorkDayDuration / 60;
            return this._balanceNumberFormatter.format(balance);
        }
        else
            return "-";
    }

    static formatChartType(chartType) {
        var chartTypeMessageKey;
        switch (chartType) {
            case APReportChartType.LEAVE_TIME:
                chartTypeMessageKey = "common.reports.chart_type_selector.leave_time";
                break;
            case APReportChartType.PTO_BALANCE:
                chartTypeMessageKey = "common.reports.chart_type_selector.pto_balance";
                break;
            case APReportChartType.SICK_BALANCE:
                chartTypeMessageKey = "common.reports.chart_type_selector.sick_balance";
                break;
        }

        return messageResource.getMessage(chartTypeMessageKey);
    }

    static makeBalanceTemplateModel(balanceType, firstGroupingLevel, secondGroupingLevel, startDate, endDate) {
        var titleKey = balanceType == BalanceType.PTO ? "report.leaves.balance_column_name.pto" : "report.leaves.balance_column_name.sick_days";
        var unitKey = balanceType == BalanceType.PTO && window.SystemSettings.showPTOInHours || balanceType == BalanceType.SICK && window.SystemSettings.showSickInHours ? "common.pto_units.hours" : "common.pto_units.days";
        var firstLevelStartDateKey, firstLevelEndDateKey, secondLevelStartDateKey, secondLevelEndDateKey;
        switch (firstGroupingLevel) {
            case ReportGroupingLevel.DATE:
                firstLevelStartDateKey = "report.leaves.first_balance_subcolumn.dates";
                firstLevelEndDateKey = "report.leaves.second_balance_subcolumn.dates";
                break;
            case ReportGroupingLevel.WEEK:
                firstLevelStartDateKey = "report.leaves.first_balance_subcolumn.weeks";
                firstLevelEndDateKey = "report.leaves.second_balance_subcolumn.weeks";
                break;
            case ReportGroupingLevel.MONTH:
                firstLevelStartDateKey = "report.leaves.first_balance_subcolumn.months";
                firstLevelEndDateKey = "report.leaves.second_balance_subcolumn.months";
                break;
        }
        switch (secondGroupingLevel) {
            case ReportGroupingLevel.DATE:
                secondLevelStartDateKey = "report.leaves.start_of_the_day";
                secondLevelEndDateKey = "report.leaves.end_of_the_day";
                break;
            case ReportGroupingLevel.WEEK:
                secondLevelStartDateKey = "report.leaves.start_of_the_week";
                secondLevelEndDateKey = "report.leaves.end_of_the_week";
                break;
            case ReportGroupingLevel.MONTH:
                secondLevelStartDateKey = "report.leaves.start_of_the_month";
                secondLevelEndDateKey = "report.leaves.end_of_the_month";
                break;
        }

        return {
            title: messageResource.getMessage(titleKey),
            startDate: firstLevelStartDateKey ? messageResource.getMessage(firstLevelStartDateKey) : super.formatDateForHeader(startDate),
            endDate: firstLevelEndDateKey ? messageResource.getMessage(firstLevelEndDateKey) : super.formatDateForHeader(endDate),
            startDateDetails: secondLevelStartDateKey ? messageResource.getMessage(secondLevelStartDateKey) : "",
            endDateDetails: secondLevelEndDateKey ? messageResource.getMessage(secondLevelEndDateKey) : "",
            unit: messageResource.getMessage(unitKey)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/FormatUtils.js